import { Fragment } from "react";
import "react-bootstrap/dist/react-bootstrap.min.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import useUserInformation from "./hooks/useUserInformation";
import Authentication from "./pages/authentication";
import CityCheck from "./pages/city/CityCheck";
import Shipments from "./pages/districtManager/Shipments";
import Supervisors from "./pages/districtManager/Supervisors";
import Driver from "./pages/driver/driver";
import Login from "./pages/public/auth/login";
import Logout from "./pages/public/auth/logout";
import TokenLogin from "./pages/public/auth/tokenLogin";
import Returned from "./pages/public/marsoolat/Returned";
import ShowPage from "./pages/public/marsoolat/show";
import AfterRentReport from "./pages/public/reports/afterRentReport";
import Agents from "./pages/supervisor/Agents";
import SupervisorShipments from "./pages/supervisor/Shipments";
import Tickets from "./pages/supervisor/Tickets";
import TodayShipments from "./pages/supervisor/TodayShipments";
import ShowWallet from "./pages/wallet/show";
import Credit from "./pages/supervisor/Credit";
import ListShipmentsPage from "./pages/public/myShipment/ListShipmentsPage";
import DigikalaCoworkerToday from "./pages/digikalaCoworker/Today/DigikalaCoworkerToday";
import DigikalaCoworkerCredit from "./pages/digikalaCoworker/credit/DigikalaCoworkerCredit";
import DigikalaCoworkerList from "./pages/digikalaCoworker/list/DigikalaCoworkerList";

function App() {
  const { isAgent, isSupervisor, isDistrictManger, isDigikalaCoworker } =
    useUserInformation();

  const getIndexPage = () => {
    if (isSupervisor || isDistrictManger) {
      return <TodayShipments />;
    }

    if (isDigikalaCoworker) {
      return <DigikalaCoworkerToday />;
    }

    return <ShowPage status="جمع آوری نشده" />;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Authentication />}>
          <Route path="/login" element={<Login />} />
          <Route path="/tokenLogin/:token" element={<TokenLogin />} />
          <Route path="/wallet" element={<ShowWallet />} />

          <Route path="city-check" element={<CityCheck />} />
          <Route path="/logout" element={<Logout />} />

          {isAgent && (
            <Fragment>
              <Route path="/overhung" element={<ShowPage status="معلق" />} />
              <Route
                path="/driverWait"
                element={<ShowPage status="ارجاع به راننده" />}
              />
              <Route path="/delivered" element={<ShowPage status="پایان" />} />
              <Route
                path="/collected"
                element={<ShowPage status="جمع آوری نشده" />}
              />
              <Route
                path="/transferring"
                element={<ShowPage status="تحویل داده شده" />}
              />
              <Route path="/returned" element={<Returned />} />
              <Route
                path="/deliveredcostomer"
                element={<ShowPage status="تحویل مشتری" />}
              />

              <Route path="/myShipmentPage" element={<ListShipmentsPage />} />
              <Route path="/afterRentReport" element={<AfterRentReport />} />
              <Route path="/driver" element={<Driver />} />
            </Fragment>
          )}

          {isSupervisor && (
            <Fragment>
              <Route
                path="/supervisor/todey-shipments"
                element={<TodayShipments />}
              />
              <Route
                path="/supervisor/shipments"
                element={<SupervisorShipments />}
              />
              <Route path="/supervisor/agents" element={<Agents />} />
              <Route path="/supervisor/credit" element={<Credit />} />
              <Route path="/supervisor/tickets" element={<Tickets />} />
            </Fragment>
          )}

          {isDistrictManger && (
            <Fragment>
              <Route
                path="/district-manager/todey-shipments"
                element={<TodayShipments />}
              />
              <Route
                path="/district-manager/shipments"
                element={<Shipments />}
              />
              <Route
                path="/district-manager/supervisors"
                element={<Supervisors />}
              />
            </Fragment>
          )}

          {isDigikalaCoworker && (
            <Fragment>
              <Route
                path="/digikala/coworker/today"
                element={<DigikalaCoworkerToday />}
              />

              <Route
                path="/digikala/coworker/list"
                element={<DigikalaCoworkerList />}
              />

              <Route
                path="/digikala/coworker/credit"
                element={<DigikalaCoworkerCredit />}
              />
            </Fragment>
          )}

          <Route path="/" element={getIndexPage()} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
